import { getFontFamilies } from "designSystem/fonts";
import { froalaLicense } from "csi/sessionConstants";
import { DefineIcon, DefineIconTemplate } from "froala-editor";
import attachFileIconSrc from "./attach-file.png";
import preSendIconSrc from "./froala-pre-send.png";
import sendReadyIconSrc from "./froala-send-ready.png";
import openInNewIconSrc from "./open-in-new.png";
import { MENTION_USER_URL } from "./tributeService";

export const BUTTON_ATTACH = "attachButton";
export const BUTTON_OPEN_IN_NEW = "openInNewButton";

export const CSS_DISABLE = "fr-disabled";
export const CSS_HIDDEN = "fr-hidden";
export const CSS_SELECTED = "fr-selected";
export const CSS_SHOW = "fr-show";

export enum ButtonIcon {
	send = "send-ready",
	preSend = "pre-send",
	attach = "attach",
	openInNew = "open-in-new",
	markImportant = "mark-important",
}

DefineIconTemplate("material_design", "<i class=\"material-icons\">[NAME]</i>");

DefineIcon(ButtonIcon.send, { template: "image", SRC: sendReadyIconSrc });
DefineIcon(ButtonIcon.preSend, { template: "image", SRC: preSendIconSrc });
DefineIcon(ButtonIcon.attach, { template: "image", SRC: attachFileIconSrc });
DefineIcon(ButtonIcon.openInNew, { template: "image", SRC: openInNewIconSrc });
DefineIcon(ButtonIcon.markImportant, { template: "material_design", NAME: "priority_high" });

export const defaultConfig = {
	attribution: false,
	autofocus: true,
	charCounterCount: false,
	imagePaste: false,
	emoticonsUseImage: false,
	fontFamily: getFontFamilies(),
	fontSizeSelection: true,
	htmlAllowedAttrs: ["style", MENTION_USER_URL, "href"],
	key: froalaLicense,
	linkAlwaysBlank: true,
	paragraphFormat: {
		N: "Normal",
		H1: "Heading 1",
		H2: "Heading 2",
		H3: "Heading 3",
		H4: "Heading 4",
	},
	theme: "csi-froala-react",
	wordPasteModal: false,
};

export const commandFont = ["emoticons", BUTTON_ATTACH, "bold", "italic", "underline"];
export const commandFormat = ["fontFamily", "fontSize", , "textColor", "paragraphFormat", "clearFormatting",
	"align", "formatOLSimple", "formatUL", "indent", "outdent"];
export const commandOther = ["insertTable", "undo", "redo"];
